import { render, staticRenderFns } from "./dish-list.vue?vue&type=template&id=7154cde5&scoped=true"
import script from "./dish-list.vue?vue&type=script&lang=js"
export * from "./dish-list.vue?vue&type=script&lang=js"
import style0 from "./dish-list.vue?vue&type=style&index=0&id=7154cde5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7154cde5",
  null
  
)

export default component.exports